import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogService } from '@bca-core/modules/dialog/services/dialog.service';
import { DialogIdentifier } from '@bca-shared/models/_enums';
import { createAction } from '@bca-store/models/action-creator';
import { IRootState } from '@bca-store/store.reducers';
import { ImageDialogState } from '@bca-user-data/models/_enums';
import { IFaceImage } from '@bca-user-data/models/face-image';
import { IMetric } from '@bca-user-data/models/metric';
import * as userDataActions from '@bca-user-data/store/user-data.actions';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IAction } from '@bca-store/models/action';

@Component({
  selector: 'bca-image-upload',
  templateUrl: 'image-upload.component.html',
  styleUrls: ['image-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageUploadComponent {
  isUploading$: Observable<boolean>;
  dialogState$: Observable<ImageDialogState>;
  faceImage$: Observable<IFaceImage>;
  faceImageMetrics$: Observable<IMetric[]>;

  ImageDialogState = ImageDialogState;

  constructor(private _store$: Store<IRootState>, private _dialogService: DialogService) {
    this.isUploading$ = this._store$.pipe(select(({ userData }) => userData.imageUploading));
    this.dialogState$ = this._store$.pipe(select(({ userData }) => userData.imageDialogState));
    this.faceImage$ = this._store$.pipe(select(({ userData }) => userData.faceImage));
    this.faceImageMetrics$ = this._store$.pipe(select(({ userData }) => userData.faceImageMetrics));
  }

  onFileSelected(file: File): void {
    this._store$.dispatch(this._createAction(new userDataActions.StartImageUpload(file)));
  }

  onSave(): void {
    this._dialogService.close(DialogIdentifier.Image);
    this._store$.dispatch(this._createAction(new userDataActions.SaveImage()));
    this._store$.dispatch(this._createAction(new userDataActions.SetImage(null)));
    this._store$.dispatch(
      this._createAction(
        new userDataActions.SetImageDialogState({ state: ImageDialogState.CHOOSE })
      )
    );
  }

  onChecked(checked: boolean): void {
    this._store$.dispatch(
      this._createAction(new userDataActions.SetAuthorizedSavePermission({ checked }))
    );
  }

  onChoose(): void {
    this._store$.dispatch(
      this._createAction(
        new userDataActions.SetImageDialogState({ state: ImageDialogState.CHOOSE })
      )
    );
    this._store$.dispatch(this._createAction(new userDataActions.SetImage(null)));
    this._store$.dispatch(this._createAction(new userDataActions.SetImageMetrics(null)));
  }

  onCancel(): void {
    this._dialogService.close(DialogIdentifier.Image);
  }

  private _createAction(action: IAction): IAction {
    return createAction(action, ImageUploadComponent);
  }
}
